<template>
   <div>
  <div class="md:flex p-6 btn-transparent min-h-screen flex justify-center items-center" style="background-color: #2D2E2C; ">
    <div class="w-full max-w-md">
      <logo/>
      <form class="mt-6 bg-transparent rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-1">
          <text-input v-model="form.nombres" :error="form.errors.nombres" style="color: white;" class="pr-6 pb-4 w-full lg:w-6/6font-bold mt-2" type="text" label="Nombres" placeholder="Milton T" required/>
          <text-input v-model="form.email" :error="form.errors.email" style="color: white;" class="pr-6 pb-4 w-full lg:w-6/6 font-bold mt-2" type="email" autofocus autocapitalize="off" label="Email" placeholder="mito@gmail.com" required/>
          <div class="pr-6 pb-4 w-full lg:w-6/6">
            <label style="color: white; font-weight: 700;" class="form-label" >Teléfono:</label>
              <VuePhoneNumberInput v-model="form.telefono" dark="true" default-country-code="EC"  @update="loaded($event)" required/>
            </div>
          
          <text-input v-model="form.password" :error="form.errors.password" class="pr-6 pb-4 w-full lg:w-6/6 font-bold mt-2"  type="password" label="Contraseña" placeholder="Contraseña" required/>
          <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
          <div class="flex justify-center items-center">
          <br>
          <loading-button v-if="valida==true" :loading="form.processing" class="px-10 py-2 btn-indigoOrange ml-auto" type="submit"  style="align-content: end;">Registrarme</loading-button>
          <br>   <br> <br>   <br>
        </div>
        </div>
      </form>
    </div>
  </div>
 </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButtonOrange'

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
    VuePhoneNumberInput,
  },
  data() {
    return {
      valida: false,
      mensagge: '',
      form: this.$inertia.form({
        nombres: '',
        email: '',
        password: '',
        remember: false,
        codigo: '',
        token: '',
        nombres: '',
        telefono: '',

      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.route('register.store'))
    },
    loaded(e){
      
      if(e.isValid)
      {

        this.form.codigo=e.formattedNumber;
        this.valida =true;
      }
      else{
        this.valida = false;
      }
      
    }
  },
}
</script>
